
import axios from "axios";
import Config from "src/config";

const v2_actionEditarCalendario = (id, data) => {
    let content = {
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/calendarios/${id}/editar`,
        data
    }
    return axios(content);
};
export default v2_actionEditarCalendario;
